module.exports = __webpack_public_path__ + "img/back_width.5123838f.png";